export default function containsDataURL(text: string): boolean {
    return text.startsWith("data:");
}
